import React from 'react';
import { AlertTriangle, X, Info, AlertCircle } from 'lucide-react';

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  type = 'danger'
}) => {
  if (!isOpen) return null;

  const typeConfig = {
    danger: {
      icon: AlertTriangle,
      iconBg: 'bg-red-50',
      iconColor: 'text-red-600',
      buttonBg: 'bg-red-600 hover:bg-red-700',
      accentColor: 'border-l-red-500'
    },
    warning: {
      icon: AlertCircle,
      iconBg: 'bg-amber-50',
      iconColor: 'text-amber-600',
      buttonBg: 'bg-amber-600 hover:bg-amber-700',
      accentColor: 'border-l-amber-500'
    },
    info: {
      icon: Info,
      iconBg: 'bg-blue-50',
      iconColor: 'text-blue-600',
      buttonBg: 'bg-blue-600 hover:bg-blue-700',
      accentColor: 'border-l-blue-500'
    }
  };

  const config = typeConfig[type] || typeConfig.danger;
  const Icon = config.icon;

  return (
    <div className="fixed inset-0 bg-ink-900/40 backdrop-blur-sm flex items-center justify-center z-[9999] animate-fade-in">
      <div className="bg-white rounded-xl shadow-lifted w-full max-w-md mx-4 animate-scale-in overflow-hidden">
        {/* Header */}
        <div className="px-6 py-5 border-b border-ink-100 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className={`w-10 h-10 ${config.iconBg} rounded-lg flex items-center justify-center`}>
              <Icon size={20} className={config.iconColor} />
            </div>
            <h2 className="text-lg font-semibold text-ink-900">{title}</h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-ink-400 hover:text-ink-600 hover:bg-ink-50 rounded-lg transition-colors"
          >
            <X size={18} />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-5">
          <div className={`bg-ink-50 border-l-4 ${config.accentColor} p-4 rounded-r-lg`}>
            <p className="text-sm text-ink-600 leading-relaxed">{message}</p>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 bg-ink-50 flex gap-3">
          <button
            onClick={onClose}
            className="
              flex-1 px-4 py-2.5
              bg-white border border-ink-200 rounded-lg
              text-ink-700 text-sm font-medium
              hover:bg-ink-50 hover:border-ink-300
              transition-colors
            "
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className={`
              flex-1 px-4 py-2.5
              ${config.buttonBg} rounded-lg
              text-white text-sm font-medium
              transition-colors
            `}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
